// extracted by mini-css-extract-plugin
export default {"greetingHeader":"GreetingHeader-module__greetingHeader--WYS7f"};